/**
 * Static list of locations supported by the Page Editor.
 * This is a subset of all available Locations.
 */
export const CUSTOMIZABLE_LOCATIONS = ['CRM_OBJECT_PREVIEW', 'HELPDESK_SIDEBAR', 'CRM_RECORD_PAGE', 'CRM_RECORD_MIDDLE', 'ACTIVITIES_TAB', 'CRM_RECORD_LEFT', 'CRM_RECORD_RIGHT', 'DEAL_EXECUTION_SIDEBAR', 'ACCOUNT_PREVIEW_TABBED'];